import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "Seed Park India";
const BASE_URL = "https://seedpark.in";
const DEFAULT_TITLE = `${SITE} | Advanced Genetics. Higher Yields.`;

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const SEO = ({ title, description }) => {
  const location = useLocation();

  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : DEFAULT_TITLE;
    const url = `${BASE_URL}${location.pathname}`;
    document.title = fullTitle;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:title", fullTitle);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, location.pathname]);

  return null;
};

export default SEO;
